export const roles = [
  { value: "sourcing_admin", label: "Sourcing admin" },
  { value: "workforce_admin", label: "Workforce Admin" },
];
